// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Мережа експертів» (Expert network, ключ `xnet`, група `experts`). */
export const expertNetworkManifest: IModuleManifest = {
  key: 'xnet',
  group: 'experts',
  slug: 'expert-network',
  prefix: 'XNT',
  name: { en: 'Expert network', uk: 'Мережа експертів' },
  entities: [
    { key: 'xnet', slug: 'xnet', name: { en: 'Experts', uk: 'Експерти' }, main: true },
    { key: 'xinst', slug: 'xinst', name: { en: 'Expert institutions', uk: 'Експертні установи' }, main: false },
    { key: 'xeng', slug: 'xeng', name: { en: 'Engagements', uk: 'Залучення' }, main: false },
  ],
  loadState: () => import('./state/expertNetworkSlice').then((m) => m.expertNetworkSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
